import { useTranslation } from 'react-i18next';
import './PublicPage.css';

export default function ImprintPage() {
    const { t } = useTranslation();
    return (
        <div className="public-page imprint-page">
            <header className="public-hero">
                <div className="public-hero-content">
                    <h1>{t('imprint.hero_title')}</h1>
                    <p>{t('imprint.hero_subtitle')}</p>
                </div>
            </header>

            <div className="legal-content-wrapper legal-text">
                <h2>{t('imprint.hero_title')} RAISIS GROUP SRL</h2>

                <div className="modern-card" style={{ padding: '32px', marginBottom: '40px' }}>
                    <p style={{ margin: '0 0 16px 0' }}><strong>{t('imprint.company_name')}:</strong><br />
                        RAISIS GROUP SRL</p>

                    <p style={{ margin: '0 0 16px 0' }}><strong>{t('imprint.registered_office')}:</strong><br />
                        Str. Narciselor 5H, Sc. A, Ap. 6, Suceava, 720207, Romania</p>

                    <p style={{ margin: '0 0 16px 0' }}><strong>{t('imprint.commercial_register')}:</strong><br />
                        J33/1241/2019</p>

                    <p style={{ margin: '0 0 16px 0' }}><strong>{t('imprint.registration_authority')}:</strong><br />
                        Registrul Comerțului Suceava</p>

                    <p style={{ margin: '0 0 16px 0' }}><strong>{t('imprint.represented_by')}:</strong><br />
                        Razvan Ungurasu (CEO)</p>

                    <p style={{ margin: '0 0 16px 0' }}><strong>{t('imprint.general_email')}:</strong><br />
                        <a href="mailto:hello@raisissoftware.com">hello@raisissoftware.com</a></p>

                    <p style={{ margin: '0' }}><strong>{t('imprint.vat_id')}:</strong><br />
                        {t('imprint.vat_ident')}: RO41337179</p>
                </div>

                <p style={{ opacity: 0.8 }}><em>{t('imprint.dispute_note')}</em></p>

                <h2>{t('imprint.liability_content_title')}</h2>
                <p>{t('imprint.liability_content_text')}</p>

                <h2>{t('imprint.liability_links_title')}</h2>
                <p>{t('imprint.liability_links_text')}</p>

                <h2>{t('imprint.copyright_title')}</h2>
                <p>{t('imprint.copyright_text')}</p>

                <h2>{t('imprint.language_title')}</h2>
                <p>{t('imprint.language_text')}</p>
            </div>
        </div>
    );
}
